import { render, staticRenderFns } from "./serverAdmin.vue?vue&type=template&id=f8eca1fc&scoped=true"
import script from "./serverAdmin.vue?vue&type=script&lang=js"
export * from "./serverAdmin.vue?vue&type=script&lang=js"
import style0 from "./serverAdmin.vue?vue&type=style&index=0&id=f8eca1fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8eca1fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8eca1fc')) {
      api.createRecord('f8eca1fc', component.options)
    } else {
      api.reload('f8eca1fc', component.options)
    }
    module.hot.accept("./serverAdmin.vue?vue&type=template&id=f8eca1fc&scoped=true", function () {
      api.rerender('f8eca1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/serverAdmin.vue"
export default component.exports